import React from 'react';

import type { MenuProps } from '@atlaskit/select/types';

import { type SingleOption } from '../../../../common/types';

export const Menu = ({
	innerRef,
	innerProps,
	children,
}: MenuProps<SingleOption, boolean>): React.JSX.Element => (
	<div data-testid="refinement-bar.common.ui.select.menu" ref={innerRef} {...innerProps}>
		{children}
	</div>
);
